import React, { useState, useRef } from "react";
import styled from "styled-components";
import CustomRadio from "../components/common/Radio/CustomRadio";
import { SquareButton } from "../components/common";
import RequiredIcon from "../assets/images/icons/ic-required.svg";
import inquireManager from "../apis/inquire";
import { closeConfirm, openConfirm } from "../redux/ConfirmSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Inquire = () => {
    const [selected, setSelected] = useState("payment");
    const [paymentsType, setPaymentsType] = useState("directBankDeposit");
    const [title, setTitle] = useState("");
    const [url, setUrl] = useState("");
    const [appId, setAppId] = useState("");
    const [email, setEmail] = useState("");
    const [contents, setContents] = useState("");
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const selectFunc = (option) => {
        fileInputRef.current.value = "";
        setFile(null);
        setFileName("");
        setTitle("");
        setUrl("");
        setAppId("");
        setEmail("");
        setContents("");
        setPaymentsType("directBankDeposit");
        setSelected(option);
    };

    const handleUploaderClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    };

    const goToHome = () => {
        navigate("/");
    }

    const handleSave = async () => {
        if (
            title === "" ||
            email === "" ||
            url === ""
        ) {
            dispatch(
                openConfirm({
                    confirmText: "확인",
                    text: "필수 정보를 입력해 주세요.",
                    isSingleButton: true,
                    confirmFunc: () => {
                        dispatch(closeConfirm());
                    },
                })
            );
        } else {
            if (file instanceof Blob) {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("title", title);
                formData.append("url", url);
                formData.append("appId", appId);
                formData.append("email", email);
                formData.append("contents", contents);
                formData.append("inquire_type", selected);
                if (selected === "payment") {
                    formData.append("payments_type", paymentsType);
                }
                await inquireManager.uploadImage(formData);
            } else {
                const inquireInfo = {
                    title: title,
                    url: url,
                    appId: appId,
                    email: email,
                    contents: contents,
                    inquire_type: selected,
                };
                if (selected === "payment") {
                    inquireInfo.payments_type = paymentsType;
                }
                await inquireManager.sendMail(inquireInfo);
            }

            fileInputRef.current.value = "";
            setFile(null);
            setFileName("");
            setTitle("");
            setUrl("");
            setAppId("");
            setEmail("");
            setContents("");
            setSelected("payment");
            setPaymentsType("directBankDeposit");
            dispatch(
                openConfirm({
                    confirmText: "확인",
                    text: "감사합니다!\n이너뷰에게 전송되었습니다.",
                    isSingleButton: true,
                    confirmFunc: () => {
                        dispatch(closeConfirm());
                    },
                })
            );
        }
    };

    return (
        <InquirePageContainer>
            <InquireTitle>문의하기</InquireTitle>
            <InquireHeaderContainer>
                <PaymentsInquire checked={selected}>
                    <div>
                        <CustomRadio
                            text="결제문의"
                            name="custom-radio"
                            value="payment"
                            checked={selected === "payment"}
                            onChange={() => selectFunc("payment")}
                        />
                    </div>
                </PaymentsInquire>
                <ErrorInquire checked={selected}>
                    <div>
                        <CustomRadio
                            text="오류문의"
                            name="custom-radio"
                            value="error"
                            checked={selected === "error"}
                            onChange={() => selectFunc("error")}
                        />
                    </div>
                </ErrorInquire>
                <EtcInquire checked={selected}>
                    <div>
                        <CustomRadio
                            text="기타문의"
                            name="custom-radio"
                            value="etc"
                            checked={selected === "etc"}
                            onChange={() => selectFunc("etc")}
                        />
                    </div>
                </EtcInquire>
            </InquireHeaderContainer>
            <InquireBodyContainer>
                <TableContainer>
                    <tbody>
                        <TableRowArea>
                            <TableTitle $height={56}>
                                제목
                                <Required src={RequiredIcon} alt={"*"} />
                            </TableTitle>
                            <TableData $height={56}>
                                <TdInner>
                                <TableInput
                                    type="text"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                </TdInner>
                            </TableData>
                        </TableRowArea>
                        <TableRowArea>
                            <TableTitle $height={56}>
                                설치 쇼핑몰 URL
                                <Required src={RequiredIcon} alt={"*"} />
                            </TableTitle>
                            <TableData $height={56}>
                                <TdInner>
                                <TableInput
                                    type="text"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                />
                                </TdInner>
                            </TableData>
                        </TableRowArea>
                        <TableRowArea>
                            <TableTitle $height={56}>설치 앱 아이디</TableTitle>
                            <TableData $height={56}>
                                <TdInner>
                                <TableInput
                                    type="text"
                                    value={appId}
                                    onChange={(e) => setAppId(e.target.value)}
                                />
                                </TdInner>
                            </TableData>
                        </TableRowArea>
                        <TableRowArea>
                            <TableTitle $height={56}>
                                담당자 이메일
                                <Required src={RequiredIcon} alt={"*"} />
                            </TableTitle>
                            <TableData $height={56}>
                                <TdInner>
                                <TableInput
                                    type="text"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                </TdInner>
                            </TableData>
                        </TableRowArea>
                        <TableRowArea>
                            <TableTitle $height={100}>내용</TableTitle>
                            <TableData $height={100}>
                                <TdInner>
                                <TableTextArea
                                    value={contents}
                                    onChange={(e) =>
                                        setContents(e.target.value)
                                    }
                                />
                                </TdInner>
                            </TableData>
                        </TableRowArea>
                        {selected === "payment" ? (
                            <>

                                <TableRowArea>
                                    <TableTitle $height={80}>사업자등록증</TableTitle>
                                    <TableFileUpload $height={80}>
                                        <TdInner>
                                        <FileUploadHidden
                                            type="file"
                                            name="image"
                                            className="err-inquire-file"
                                            accept="image/*"
                                            ref={fileInputRef}
                                            onChange={(e) =>
                                                handleFileChange(e)
                                            }
                                        />
                                        <FileUploader>
                                            <SquareButton
                                                size="lg"
                                                onClick={handleUploaderClick}
                                            >
                                                첨부파일
                                            </SquareButton>
                                            <FileNameArea>
                                                {fileName}
                                            </FileNameArea>
                                        </FileUploader>
                                        </TdInner>
                                    </TableFileUpload>
                                </TableRowArea>
                                <TableRowArea>
                                    <TableTitle $height={56}>결제형태</TableTitle>
                                    <TablePaymentsType $height={56}>
                                        <TdInner>
                                        <Label htmlFor="payments-type1">
                                            <input
                                                id="payments-type1"
                                                type="radio"
                                                name="payments-type"
                                                value="directBankDeposit"
                                                checked={
                                                    paymentsType ===
                                                    "directBankDeposit"
                                                }
                                                onChange={() =>
                                                    setPaymentsType(
                                                        "directBankDeposit"
                                                    )
                                                }
                                            />
                                            무통장입급
                                        </Label>
                                        <Label htmlFor="payments-type2">
                                            <input
                                                id="payments-type2"
                                                type="radio"
                                                name="payments-type"
                                                value="bankTransfer"
                                                checked={
                                                    paymentsType ===
                                                    "bankTransfer"
                                                }
                                                onChange={() =>
                                                    setPaymentsType(
                                                        "bankTransfer"
                                                    )
                                                }
                                            />
                                            계좌이체
                                        </Label>
                                        </TdInner>
                                    </TablePaymentsType>
                                </TableRowArea>
                            </>
                        ) : (
                            <>
                                <TableRowArea>
                                    <TableTitle $height={80}>첨부파일</TableTitle>
                                    <TableFileUpload $height={80}>
                                        <TdInner>
                                        <FileUploadHidden
                                            type="file"
                                            name="image"
                                            className="payments-inquire-file"
                                            accept="image/*"
                                            ref={fileInputRef}
                                            onChange={(e) =>
                                                handleFileChange(e)
                                            }
                                        />
                                        <FileUploader>
                                            <SquareButton
                                                size="lg"
                                                onClick={handleUploaderClick}
                                            >
                                                등록하기
                                            </SquareButton>
                                            <FileNameArea>
                                                {fileName}
                                            </FileNameArea>
                                        </FileUploader>
                                        </TdInner>
                                    </TableFileUpload>
                                </TableRowArea>
                            </>
                        )}
                    </tbody>
                </TableContainer>
            </InquireBodyContainer>
            <InquireFooterContainer>
                <CancelBtn onClick={goToHome}>취소</CancelBtn>
                <SaveBtn onClick={handleSave}>저장</SaveBtn>
            </InquireFooterContainer>
        </InquirePageContainer>
    );
};
const TdInner = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
`;
const InquirePageContainer = styled.div`
    margin-top: 15px;
    padding: 72px;
    width: 100vw;
    height: 100vh;
    min-width: 1390px;
    min-height: 500px;
`;

const InquireTitle = styled.p`
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #282B39;
`;

const InquireHeaderContainer = styled.div`
    display: flex;
    margin-top: 40px;
    width: 80%;
    height: 6vh;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.15);
    align-items: center;
    gap: 45px;
`;

const PaymentsInquire = styled.div`
    display: flex;
    width: 180px;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-bottom: ${(props) =>
        props.checked === "payment" ? "3px solid #7386E8" : ""};
`;

const ErrorInquire = styled.div`
    display: flex;
    width: 180px;
    height: 100%;
    gap: 30px;
    align-items: center;
    justify-content: center;
    border-bottom: ${(props) =>
        props.checked === "error" ? "3px solid #7386E8" : ""};
`;

const EtcInquire = styled.div`
    display: flex;
    width: 180px;
    height: 100%;
    gap: 30px;
    align-items: center;
    justify-content: center;
    border-bottom: ${(props) =>
        props.checked === "etc" ? "3px solid #7386E8" : ""};
`;

const InquireBodyContainer = styled.div`
    width: 80%;
    margin-top: 30px;
    //height: 450px;
`;


const TableRowArea = styled.tr`
    vertical-align: middle;
`;

const TableContainer = styled.table`
    width: 100%;
    //height: 100%;
`;
const TableTitle = styled.td`
    width: 180px;
    max-height: 130px;
    padding-left: 40px;
    font-weight: bold;
    background-color: rgb(240, 240, 245);
    height: ${(props) => props.$height}px;
    min-height: ${(props) => props.$height}px;
`;

const TableData = styled.td`
    padding-left: 40px;
    height: ${(props) => props.$height}px;
    min-height: ${(props) => props.$height}px;
`;

const TableInput = styled.input`
    width: 100%;
    height: 30px;
    padding-left: 10px;
    outline-color: rgb(238, 238, 240);
    border: 1px solid rgb(238, 238, 240);
`;

const TableTextArea = styled.textarea`
    width: 100%;
    height: 70px;
    padding: 10px;
    outline-color: rgb(238, 238, 240);
    border: 1px solid rgb(238, 238, 240);
`;

const TablePaymentsType = styled.td`
    padding-left: 40px;
    height: 80px;
    margin-bottom: 10px;
`;

const TableFileUpload = styled.td`
    padding-left: 40px;
    height: 80px;
    margin-bottom: 10px;
`;

const Label = styled.label`
    margin-right: 20px;
`;

const FileUploadHidden = styled.input`
    display: none;
`;

const InquireFooterContainer = styled.div`
    display: flex;
    width: 80%;
    justify-content: center;
    margin-top: 40px;
    gap: 10px;
`;

const CancelBtn = styled.button`
    transition: 0.2s ease-in-out;
    cursor: pointer;
    padding: 0px 56px;
    height: 48px;
    font-size: 16px;
    border: 1px solid var(--gray-black);
    background-color: #fff;
    border-radius: 50px;
    color: var(--gray-black);
    font-weight: 700;
`;

const SaveBtn = styled.button`
    transition: 0.2s ease-in-out;
    cursor: pointer;
    padding: 0px 56px;
    height: 48px;
    font-size: 16px;
    border: 1px solid var(--gray-black);
    background-color: var(--gray-black);
    border-radius: 50px;
    color: rgb(255, 255, 255);
    font-weight: 700;
`;

const Required = styled.img`
    margin-left: 10px;
    margin-bottom: 2px;
`;

const FileUploader = styled.div`
    display: flex;
`;

const FileNameArea = styled.p`
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 20px;
`;

export default Inquire;
